import { ChevronRight } from 'lucide-react';
import inicioIMG from '../images/imgInicio.webp';

import './Home.css';
import { FaStar } from 'react-icons/fa';  // Importando la versión sólida


const phoneNumber = "+56983221037"; // Reemplaza con el número de WhatsApp en formato internacional
const message = encodeURIComponent("Hola, me gustaría solicitar información sobre los velatorios."); // Mensaje predefinido

const whatsappLink = `https://wa.me/${phoneNumber}/?text=${message}`;

const images = [
  inicioIMG,

]

const reviews = [
  {
    name: "Ariel Esteban Vidal Osorio",
    date: "Septiembre de 2024",
    rating: 5,
    comment: "Excelente servicio en todo aspecto, tanto la atención previa, los momentos más difíciles y la gestión de toda la tramitación, 10 de 10, personal eficiente, cercano y muy empático en todo sentido, un agrado como familia todo el manejo de la ceremonia. Gracias nuevamente Funeraria Coquimbo.",
  },
  {
    name: "Lissette Villalobos",
    date: "Septiembre de 2024",
    rating: 5,
    comment: "Muchas gracias por los servicios funerarios, primera vez que fallece un familiar cercano y nos ayudaron en todo el proceso, muy cercanos tanto Javier como Catalina, quienes nos guiaron en todo este duro proceso.",
  },
  {
    name: "Daniza Torres Cortes",
    date: "Septiembre de 2024",
    rating: 5,
    comment: "Muy confiables, cercanos durante todo el proceso difícil que vive uno como familia. La verdad es que lo recomiendo al mil por ciento! No se arrepentirán del servicio que brindan 🙏🏻",
  },
];

export default function VelatoriosOpinionesContacto() {

  return (
    <div>
      <div>

{/* Sección de Contacto */}
<section className="bg-[#1c1c1c] text-white py-20 p-8 sm:p-10 md:p-12 lg:p-14">
  <div className="max-w-6xl mx-auto">
    <div className="text-center mb-8">
      <h2 className="text-4xl sm:text-5xl md:text-6xl mb-4 text-gray-100 font-semibold tracking-tight">
        Estamos aquí para apoyarle
      </h2>
      <p className="text-gray-300 max-w-xl mx-auto text-lg sm:text-xl mb-6">
        Ofrecemos <span className="text-[#DBAC5B] font-semibold">asistencia</span> con compasión y dignidad.  
        <span className="text-[#DBAC5B] font-semibold"> Contáctenos</span> para más <span className="text-[#DBAC5B] font-semibold"> información</span> sobre nuestros servicios.
      </p>
    </div>
    <div className="flex flex-col items-center ">
      {/* Contenedor del número de contacto con efecto parpadeante */}
      <a
        href="tel:+56983221037"
        className="flex items-center justify-center w-full max-w-md  text-gray-100 text-3xl sm:text-4xl font-semibold"
      >
        +569 8322 1037
      </a>
      {/* Atención 24 Horas */}
      <div className="flex items-center mt-4 space-x-1">
        <svg
          className="w-6 h-6 text-[#DBAC5B]"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 8a1 1 0 0 1 1 1v3h2a1 1 0 0 1 0 2h-3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1zm0-6a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" />
        </svg>
        <span className="text-lg sm:text-xl  text-gray-300">
          Atención 24 horas, todos los días
        </span>
      </div>
    </div>
  </div>
</section>




</div>




      {/* Sección de Nuestras Salas Velatorias y Testimonios de Familias */}
      <div className="flex flex-col items-center justify-center py-16 px-4 lg:px-8 ">
        <div className="w-full max-w-6xl space-y-12 ">
          <div className="grid grid-cols-1 md:grid-cols-2  gap-12 w-full">
            {/* Sección Nuestras Salas Velatorias */}
            <div className="rounded-lg ">
              <div className="overflow-hidden flex flex-col">
                <div className="mb-4 flex items-center justify-between">
                <div className="flex flex-col mb-0">
  <h2 className="lg:text-5xl text-4xl font-bold text-left text-gray-900">
    <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700 text-left">
      Nuestras Salas Velatorias
    </span>
  </h2>
  <p className="mt-2 text-xl text-gray-600 text-left ">
    Un refugio de paz en momentos difíciles.
  </p>
</div>

                </div>

                <div className="relative h-[600px] overflow-hidden"> {/* Ajusta la altura aquí */}
      {images.map((img, index) => (
        <img
          key={index}
          src={img}
          alt={`Sala velatoria ${index + 1} Funeraria Coquimbo`}
          className="w-full h-full object-cover transition-opacity duration-500 rounded-lg" // Elimina la lógica de opacidad
          loading="lazy"
        />
      ))}
          
                </div>

                <div className="mt-1 mb-1">
                <p className="text-gray-600 text-lg text-left py-2 leading-relaxed">
  Creamos <span className="text-[#A0A0A0] font-semibold">espacios tranquilos</span> y <span className="text-[#A0A0A0] font-semibold"> confortables </span> 
  para honrar la memoria de sus seres queridos. Nuestras salas velatorias están diseñadas para ofrecer 
  <span className="text-[#A0A0A0] font-semibold"> paz</span> y <span className="text-[#A0A0A0] font-semibold"> serenidad</span> en los momentos más difíciles.
</p>

                </div>

                <a 
    href={whatsappLink}
    target="_blank"
    rel="noopener noreferrer"
    className=" sm:w-auto  border rounded-md transition-all bg-[#DBAC5B] text-white flex items-center justify-center hover:text-[#A0A0A0]"
  >
    <button 
      className="w-full py-3 px-8 border rounded-md transition-all text-[#fff] border-[#A0A0A0] bg-[#DBAC5B] hover:text-[#A0A0A0] flex items-center justify-center"
    >
      Solicitar información
      <ChevronRight className="ml-2" size={24} />
    </button>
  </a>
              </div>
            </div>

            {/* Sección Testimonios de Familias */}
            <div className=" p-2 my-auto ">
              <div className="flex flex-col">
              <div className="flex flex-col  mb-4">
  <h2 className="lg:text-5xl text-4xl font-bold text-left text-gray-900 text-right">
    <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-700">
      Testimonios de Familias
    </span>
  </h2>
  <p className="mt-2 text-xl text-gray-600 text-right">
  Compasión y Apoyo en Cada Paso  </p>
</div>

                <div className="">
                  {reviews.map((review, index) => (
                    <div key={index} className="mb-4 bg-[#F5F5F5] p-4 rounded-lg shadow">
                      <div className="flex items-center justify-between">
                        <h4 className="font-semibold text-lg text-[#1C1C1C]">{review.name}</h4>
                        <span className="text-sm text-[#4A5568]">{review.date}</span>
                      </div>
                      <div className="flex items-center mb-2">
                        {[...Array(review.rating)].map((_, i) => (
                          <FaStar key={i} className="w-5 h-5 text-[#FFD700]" />
                        ))}
                      </div>
                      <p className="text-[#1C1C1C] italic">{review.comment}</p>
                    </div>
                  ))}
                </div>
                <button 
                  className="w-full py-3 px-8 border rounded-md transition-all  text-[#fff] border-[#A0A0A0] bg-[#DBAC5B] hover:text-[#A0A0A0]  flex items-center justify-center"
                  onClick={() => window.open('https://www.google.com/maps/place/Funeraria+Coquimbo/@-29.9340618,-71.3343781,13z/data=!4m12!1m2!2m1!1sfuneraria+coquimbo!3m8!1s0x9691c9e976ef5029:0xd7d09c4f2f916806!8m2!3d-29.9655068!4d-71.3363385!9m1!1b1!15sChJmdW5lcmFyaWEgY29xdWltYm9aFCISZnVuZXJhcmlhIGNvcXVpbWJvkgEMZnVuZXJhbF9ob21lmgEjQ2haRFNVaE5NRzluUzBWSlEwRm5TVVI1TWpsUE4wdEJFQUXgAQA!16s%2Fg%2F11r3xh9m0_?entry=ttu&g_ep=EgoyMDI0MTAyMC4xIKXMDSoASAFQAw%3D%3D', '_blank')}
                >
                  Revisa nuestras reseñas en Google
                  <ChevronRight className="ml-1" size={24} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
